import { ReactNode } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";
import classNames from "classnames";

import { QA_ALL_VEHICLES_GRID_MODAL } from "../../modules/Data/static";
import "./LayoutGrid.scss";

type LayoutGridProps = {
  customClass?: string;
  children: ReactNode;
  columns?: number | string;
  gap?: number;
};

const LayoutGrid = ({
  customClass = "",
  children,
  columns = 1,
  gap = 1,
}: LayoutGridProps) => {
  const { projectClass, breakpointActive } = useUiContext();
  const getClassName = () =>
    classNames(`${projectClass}_LayoutGrid`, {
      [`${projectClass}_LayoutGrid--col-${columns}`]: columns,
      [`${breakpointActive}`]: breakpointActive,
      customClass,
    });

  const style = {
    gap: gap ? `${gap}rem` : undefined,
  };

  return (
    <div className={getClassName()} style={style} data-qa={QA_ALL_VEHICLES_GRID_MODAL}>
      {children}
    </div>
  );
};

export default LayoutGrid;
